// extracted by mini-css-extract-plugin
module.exports = {"itemLabel":"messagesimplified_itemLabel__2zt_I"};